import { usePage } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { CompanyLayout } from "~/components/company/CompanyLayout"
import { Button } from "~/components/ui/button"
import { jobsData } from "~/components/company/job_listings/mock-data"
import { JobDetailHeader } from "~/components/company/job_listings/JobDetailHeader"
import { JobDetailContent } from "~/components/company/job_listings/JobDetailContent"
import { JobContractSidebar } from "~/components/company/job_listings/JobContractSidebar"
import { JobBenefitsSection } from "~/components/company/job_listings/JobBenefitsSection"

export default function Show() {
  const { id } = usePage<{ id: string }>().props
  const job = jobsData[id]

  if (!job) {
    return (
      <CompanyLayout>
        <div className="flex flex-1 flex-col items-center justify-center py-32">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Job Not Found</h1>
          <a href="/careers">
            <Button variant="ghost" className="text-primary">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Careers
            </Button>
          </a>
        </div>
      </CompanyLayout>
    )
  }

  return (
    <CompanyLayout>
      <section className="w-full pt-8 bg-gray-50">
        <div className="container px-8 md:px-12 lg:px-16">
          <a href="/careers">
            <Button variant="ghost" className="text-gray-600 hover:text-primary p-0">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to All Positions
            </Button>
          </a>
        </div>
      </section>

      <JobDetailHeader job={job} />

      <section className="w-full py-12 md:py-16">
        <div className="container px-8 md:px-12 lg:px-16">
          <div className="grid lg:grid-cols-3 gap-8">
            <JobDetailContent job={job} />
            <JobContractSidebar job={job} />
          </div>
        </div>
      </section>

      <JobBenefitsSection />
    </CompanyLayout>
  )
}
